import { render, staticRenderFns } from "./AuthenticationFailed.vue?vue&type=template&id=70298343&"
import script from "./AuthenticationFailed.vue?vue&type=script&lang=js&"
export * from "./AuthenticationFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports